module.exports = __webpack_public_path__ + "media/images/flags/1x1/blz-55c58111e935798223023f63cfaa2e65.svg";